import IsoCountries from "i18n-iso-countries";

const getCountryName = (intl, country) =>
  IsoCountries.getName(country, intl.locale.split("-")[0].toLowerCase()) ||
  IsoCountries.getName(country, intl.defaultLocale) ||
  country;

export default getCountryName;
